//import packages from node modules
import React, {useEffect, useCallback, useRef, useState, useContext} from "react"

//import utility functions
import {getAttributes} from "../../../../utilities/function/configuration";

//import shared components
import SolidButton from '../../../shared/button/solidbutton'

//import internals
import {SelectHostingContext, UPDATE_CONFIG} from "../state";
import {getDefaultStats,getGuideConfig} from "./guideconfig"
import {BUILD_PAGE} from "./index";


//define internal functions
const renderText = (data,slug,classname=null) => {
  return data?<div className={`of-select-hosting-guide__${slug}${classname?' '+classname:''}`}>{data}</div>:<></>
}


const Guide = () => {
  const Config = getGuideConfig()
  const DefaultStats = getDefaultStats()
  const [config,setConfig] = useState({
    selected: Config['entry'],
    stats: DefaultStats,
    optionFormat: 'of-select-hosting-guide__options--row'
  })
  const initFlag = useRef(false)
  const initCallback = useCallback(()=>{
    if(!initFlag.current){
      initFlag.current = true
    }
  },[initFlag])
  const prevHelpVal = useRef(null)
  const helpCallback = useCallback(()=>{
    if(typeof config.stats !== "undefined"){
      const {help} = config.stats
      if(prevHelpVal.current !== help){
        if(help===2){
          setConfig({
            ...config,
            selected: Config['help']
          })
        }
        prevHelpVal.current = help
      }
    }
  },[config,Config,prevHelpVal])

  const {state,dispatch} = useContext(SelectHostingContext)

  useEffect(()=>{
    initCallback()
    helpCallback()
  },[initCallback,helpCallback])

  const onStartOverCallback = (e) => {
    e.preventDefault()
    setConfig({
      ...config,
      selected: Config['entry'],
      stats: DefaultStats
    })
  }

  const renderSelected = () => {
    if(config && config.selected){
      const {heading,description,options,icon,startOver,showResult,showContact} = config.selected
      const getNameFromKey = (key) =>{
        switch (key){
          case 'disk':
            return 'Disk Space'
          case 'memory':
            return 'Memory'
          case 'cpu':
            return 'CPU'
          default:
            return undefined
        }
      }
      const updateConfigBasedOnStats = () => {
        //update the config based on index
        if(config && config.stats && Object.keys(config.stats).length){
          const presetConfig = Object.keys(config.stats).map(key=>{
            //get info from addon
            if(state && state.data && state.data[0] && getAttributes(state.data[0])){
              const {config_options} = getAttributes(state.data[0])
              if(config_options && config_options.length){
                const selectedConfig = config_options.find(i=>i.name===getNameFromKey(key))
                if(selectedConfig && selectedConfig.options && selectedConfig.options.length){
                  const selectedOption = selectedConfig.options.find((item,index)=>index===config.stats[key])
                  return ({
                    config_id: selectedConfig.id,
                    option_id: selectedOption.id
                  })
                }
              }
            }
            return ({})
          })
          if(presetConfig){
              dispatch({
                type: UPDATE_CONFIG,
                config: presetConfig,
                selectedTab: BUILD_PAGE
              })
          }
        }
      }
      const renderButtons = () =>{
        const renderList = () => {
          if(options && options.length){
            return options.map((option, index) => {
              const {label,step,stats} = option
              const onClickCallback = (e) => {
                e.preventDefault()
                const getStats = () =>{
                  let newStats = Object.assign(config.stats)
                  if(step==="entry"){
                    newStats = DefaultStats
                  }else{
                    if (stats && Object.keys(stats).length) {
                      Object.keys(stats).forEach((key) => {
                        if (newStats[key]) {
                          newStats[key] = parseFloat(newStats[key]) + parseFloat(stats[key])
                        } else {
                          newStats[key] = parseFloat(stats[key])
                        }
                      })
                    }
                  }
                  return newStats
                }
                const getOptionFormat = () => {
                  let optionFormat = 'of-select-hosting-guide__options--row'
                  if(Config[step] && Config[step].options && Config[step].options.length){
                    if(Config[step].options.length >= 4){
                      optionFormat = 'of-select-hosting-guide__options--column'
                    }
                  }
                  if(Config[step] && Config[step].longOption){
                    optionFormat = 'of-select-hosting-guide__options--long'
                  }
                  return optionFormat
                }

                const newConfig = {
                  selected: Config[step],
                  stats: getStats(),
                  optionFormat: getOptionFormat()
                }
                setConfig(newConfig)
                if(step==="entry"){
                  updateConfigBasedOnStats()
                }
              }
              return (
                  <li key={index} className={`of-select-hosting-guide__options-item`}>
                    <SolidButton onClick={onClickCallback} className={`primary-background-2-100 text-font-1-100 of-select-hosting-guide__options-button`}>{label}</SolidButton>
                  </li>
              )
            })
          }
          return (<></>)
        }
        if (config && config.optionFormat) {
          const {optionFormat} = config
          return (
              <ul className={`of-select-hosting-guide__options${optionFormat?' '+optionFormat:''}`}>
                {renderList()}
              </ul>
          )
        }
        return (<></>)
      }
      const renderIcon = () => {
        if(icon){
          return <div className={`of-select-hosting-guide__icon`}>
            <span className={`text-font-1-100 icon icon-of-${icon}`}/>
          </div>
        }
        return (<></>)
      }
      const renderStartOver = () => {
        if(startOver){
          return (
              <div className={`of-select-hosting-guide__start-over-wrapper`}>
                <button onClick={onStartOverCallback} className={`of-select-hosting-guide__start-over primary-font-1-100`}>Start Over</button>
              </div>
          )
        }
        return (<></>)
      }
      const renderShowResult = () => {
        if (typeof config.stats !== "undefined" &&
            Object.keys(config.stats).length
            && showResult) {
          const renderBoxes = (key) => {
            const generateValue = () => {
              const val = parseFloat(config.stats[key])
              const name = getNameFromKey(key)
              if(state && state.data && state.data[0] && getAttributes(state.data[0])){
                const {config_options} = getAttributes(state.data[0])
                if(config_options && config_options.length){
                  const selectedConfig = config_options.find((item)=>item.name===name)
                  if(selectedConfig && selectedConfig.options){
                    const selectedOption = selectedConfig.options.find((item,index)=>index===val)
                    if(selectedOption){
                      return selectedOption.name
                    }
                  }
                }
              }
              return undefined
            }
            return (
                <div className={`of-select-hosting-guide-box shade-background-1-100`}>
                  <div className={'of-select-hosting-guide-box__wrapper'}>
                    <div className={'of-select-hosting-guide-box__value primary-font-1-100'}>{generateValue()}</div>
                    <div className={'of-select-hosting-guide-box__label text-font-1-100'}>{getNameFromKey(key)}</div>
                  </div>
                </div>
            )
          }
          return (
              <div className={`of-select-hosting-guide__stats`}>
                {renderBoxes('disk')}
                {renderBoxes('cpu')}
                {renderBoxes('memory')}
              </div>
          )
        }
        return (<></>)
      }



      const renderContact = () => {
        const renderBoxes = () => {
          if(typeof state.contact !== "undefined"){
            try {
              const data = JSON.parse(state.contact)
              if(data && Object.keys(data) && Object.keys(data).length){
                return Object.keys(data).map((key,index)=>{
                  const {icon,value} = data[key]
                  const getLabel  = () =>{
                    if(key==="Phone"){
                      return value
                    }
                    return key
                  }
                  const boxOnClick = () => {
                    switch (key){
                      case "Phone":
                        window.location.href = `tel:${value}`
                        break
                      case "Email":
                        window.location.href = `mailto:${value}`
                        break
                      case "Live Chat":
                        if (typeof window.LC_API !== "undefined") {
                          window.LC_API.open_chat_window()
                        }
                        break
                      default:
                        break
                    }
                  }
                  return (
                      <div key={index} className={'of-select-hosting-guide-box of-select-hosting-guide-box--contact shade-background-1-100'} onClick={boxOnClick}>
                        <div className={'of-select-hosting-guide-box__wrapper'}>
                          <div className={'of-select-hosting-guide-box__value primary-font-1-100'}><span className={`icon icon-${icon}`}/></div>
                          <div className={'of-select-hosting-guide-box__label text-font-1-100'}>{getLabel()}</div>
                        </div>
                      </div>
                  )
                })
              }
            }catch (e){
              console.log(e)
            }

          }
          return (<></>)
        }
        if(showContact){
          return (
              <div className={'of-select-hosting-guide-contact'}>
                <div className={'of-select-hosting-guide-contact__list'}>
                  {renderBoxes()}
                </div>
              </div>
          )
        }
        return (<></>)
      }

      return (
          <div className={'of-select-hosting-guide__wrapper'}>
            {renderIcon()}
            {renderText(heading,'heading','text-font-1-100')}
            {renderText(description,'description','text-font-3-100')}
            {renderShowResult()}
            {renderContact()}
            {renderButtons()}
            {renderStartOver()}
          </div>
      )
    }
  }

  return (
      <div className={'of-select-hosting-guide of-select-hosting-page'}>
        {renderSelected()}
      </div>
  )
}

export default Guide